export class ResearchInstruction {

  constructor(
    public researchInstruction: string) { }

  static getResearchInstruction(specialInstruction: any): string {
    let result = null;
    for (const item of specialInstruction) {
      if (item.researchInstructions.length > 0) {
        for (const research of item.researchInstructions) {
          result = research.researchInstructions;
        }
      }
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/models/ResearchInstruction.ts